// extracted by mini-css-extract-plugin
module.exports = {"ForceActivationContainer":"forceActivation_ForceActivationContainer__XTtAJ"};